export function CompactPageHeader({ title, actions, meta, testId = "compact-page-header" }) {
  return <header className="compact-page-header" data-testid={testId}><div className="compact-page-title-wrap"><h1 data-testid={`${testId}-title`}>{title}</h1>{meta && <div className="compact-page-meta" data-testid={`${testId}-meta`}>{meta}</div>}</div>{actions && <div className="compact-page-actions" data-testid={`${testId}-actions`}>{actions}</div>}</header>;
}

export function CompactToolbar({ children, testId = "compact-toolbar" }) {
  return <div className="compact-toolbar" data-testid={testId}>{children}</div>;
}

export function CompactEmptyState({ children = "Aucun élément à afficher.", testId = "compact-empty-state" }) {
  return <div className="compact-empty-state" data-testid={testId}>✓ {children}</div>;
}

export function CompactFormSection({ title, children, testId = "compact-form-section" }) {
  return <section className="compact-form-section surface" data-testid={testId}>{title && <h2 data-testid={`${testId}-title`}>{title}</h2>}{children}</section>;
}